import { updateMultipleItems } from '../../state/tac/tacReducer/updateMultipleItems';
import updateDependentItems from '../../state/tac/tacReducer/updateDependentItems';
import constants from '../../settings/constants';
import geometry from './geometry';
import tacHelpers from '../../state/tac/tacHelpers';
import { isSection } from '../../services/products';
import { round } from '../../util/round';
import productService from '../../services/products';

export function supersection_drawSuggestions(supersection, scene) {
  const updTac = updateMultipleItems(scene.tac, supersection);
  const fixedTac = updateDependentItems(updTac, {
    keepBrackets: true,
  });
  const realItemsIds = scene.tac.items.map(item => item.itemid);

  fixedTac.items
    .filter(item => !realItemsIds.includes(item.itemid))
    .forEach(tempItem => {
      // tell section that it should draw a suggestion box on itself
      tempItem.isTempItem = true;
    });

  scene.itemContainer.update({
    room: scene.room.model,
    options: scene.itemContainerOptions,
    ratio: scene.room.ratio,
    tac: fixedTac,
  });
}

export function supersection_relativePos(item, grabbedItem, drawPos) {
  return {
    x: item.x - grabbedItem.x + drawPos.x,
    y: item.y - grabbedItem.y + drawPos.y,
    z: item.z - grabbedItem.z + drawPos.z,
  };
}

export function supersection_recalc(
  supersection,
  grabbedItem,
  newItem,
  scene,
  options
) {
  const updItem = { ...newItem };
  // the grabbed item is _always_ a section,
  // so it's safe to do this x adjustment
  updItem.x += productService.getPostWidth() / 2;

  const boundingSupersection = supersection.map(item => {
    if (isSection(item)) {
      const bounds = geometry.mergeKids(
        item,
        tacHelpers.getRects(item, null, scene.tac, true)
      );
      return Object.assign({}, item, bounds);
    }
    return item;
  });
  const lowestY = Math.min.apply(
    null,
    boundingSupersection.map(item => item.y)
  );

  const bottomPadding = grabbedItem.y - lowestY;
  const gridY = scene.getGrid(constants.DRAG_MODE.FLOAT).y;

  if (!options?.lockedY) {
    updItem.y = Math.max(
      updItem.y,
      gridY.offset + bottomPadding,
      gridY.offset - bottomPadding
    );
    // now newItem.y might be off grid so readjust
    updItem.y = scene.getClosestGridPos(
      updItem.y - gridY.step / 2,
      constants.DRAG_MODE.FLOAT,
      'y',
      round
    );
  }

  const items = boundingSupersection.map(item => ({
    ...item,
    ...supersection_relativePos(item, grabbedItem, updItem),
  }));
  return {
    items,
    item: { x: updItem.x, y: updItem.y },
  };
}
